<router-outlet featureTabsTabsTitle [prefix]="'tenant-page-title-prefix' | translate"></router-outlet>
